import { useSelector } from 'react-redux';
import { AutoCompleteProps } from '@placer-ui/components';
import type { PlaceCollection } from '@placer-ui/types';
import { EntitySectionTypes, ReportTypes } from 'core/constants/report-type';
import { selectTopSearchResultsByTerm } from 'store/header/search/selectors/select-top-search-results-by-term';
import { selectTopSearchTerm } from 'store/header/search/selectors/top-search-selectors-factory';
import { useSelectorWithProps } from 'utils/structured-selector/structured-selector';
import { useIsFreemiumUser } from 'hooks/use-freemium-user/use-freemium-user';
import { MultilineItemPropsWithEntity } from 'hooks/use-entity-search/utils/convert-poi-to-auto-complete-suggestion';
import { aggregateAutocompleteSuggestions } from 'hooks/use-entity-search/use-entity-search';

type SearchAutocompleteSuggestions = {
    reportType: ReportTypes | PlaceCollection[] | undefined;
    entitySection: EntitySectionTypes | undefined;
};

export const useSearchAutocompleteSuggestions = ({
    reportType,
    entitySection,
}: SearchAutocompleteSuggestions): {
    suggestions?: AutoCompleteProps<MultilineItemPropsWithEntity>['items'];
} => {
    const term = useSelector(selectTopSearchTerm);
    const entities = useSelectorWithProps(
        { reportType, entitySection },
        selectTopSearchResultsByTerm,
    );
    const isFreemiumUser = useIsFreemiumUser();

    return {
        suggestions: entities.length
            ? aggregateAutocompleteSuggestions({
                  entities,
                  term,
                  isFreemiumUser,
              })
            : undefined,
    };
};
